export const en = {
  'signals-ng-filter-date': {
    searchField: {
      contextSearch: {
        quickSelection: {
          pastSevenDays: 'Past 7 Days',
          pastOneMonth: 'Past Month',
          pastOneQuarter: 'Past Quarter',
          pastOneYear: 'Past Year',
          pastTwoYear: 'Past 2 Years',
          pastFiveYear: 'Past 5 Years',
          fromStartOfMonth: 'From Start of Month',
          fromStartOfYear: 'From Start of Year'
        }
      }
    },
    propertyLabels: {
      publishedDateFilter: 'Select Dates',
      timeframe: 'Timeframe'
    }
  }
};
